import styled from "styled-components";
import Typography from '@mui/material/Typography';

export const StyledMenuItemContent = styled.div` 
    display: flex;
    background: white;
    flex-direction: column;
    background: transparent;
    gap: 0px;
    .title{
        font-size: 12px;
        font-weight: 300;
        margin: 0;
    }
    .subtitle{
        font-weight: 400;
        margin: 0;
        font-size: 12px;
    }
    .price{
        font-weight: 400;
        color: #6ec4e8;
        margin: 0;
        font-size: 15px;
    }
`
  